import React from 'react'

import { HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE } from '../../../_templates/Templates'
import { Label } from '../../../../../../packages/kiti/components/presentation/Text'
import {
  usePdfOptionsForm,
  usePdfOptionsFormActions
} from '../../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import PopoverColorPicker from '../../../../../../components/form/PopoverColorPicker'

const TemplateBgColor = () => {
  const form = usePdfOptionsForm()
  const { handleChange } = usePdfOptionsFormActions()

  if (![HORIZONTAL_TEMPLATE, VERTICAL_TEMPLATE].includes(form.template)) return false

  return (
    <>
      <Label color="black">Cor de fundo</Label>
      <PopoverColorPicker value={form.bgColor} color={form.bgColor} onChange={handleChange(`bgColor`)} />
    </>
  )
}

export default TemplateBgColor
